/**
 * @fileoverview Molecule: developer-facing breakdown of an error.
 * @module components/molecules/ErrorDetails
 */

import { env } from "@/config/env"
import type { AppError } from "@/lib/errors"

import "./ErrorDetails.css"

/** Props accepted by {@link ErrorDetails}. */
export interface ErrorDetailsProps {
	/** The normalised error to describe. */
	readonly error: AppError
}

/**
 * Collapsible technical details, rendered in development only.
 *
 * @param props - The error to describe.
 * @returns The details block, or null outside development.
 */
export function ErrorDetails({ error }: ErrorDetailsProps) {
	if (!env.isDevelopment) return null

	const hasContext = Object.keys(error.context).length > 0

	return (
		<details className="error-details">
			<summary className="error-details__summary">
				Détails techniques (dev uniquement)
			</summary>
			<div className="error-details__body">
				<div className="error-details__row">
					<strong>Code :</strong> {error.code}
				</div>
				{error.status !== undefined && (
					<div className="error-details__row">
						<strong>Status :</strong> {error.status}
					</div>
				)}
				<div className="error-details__row">
					<strong>Message :</strong> {error.message}
				</div>
				{hasContext && (
					<div className="error-details__row">
						<strong>Contexte :</strong>
						<pre className="error-details__pre">
							{JSON.stringify(error.context, null, 2)}
						</pre>
					</div>
				)}
				{error.stack !== undefined && (
					<div className="error-details__row">
						<strong>Stack :</strong>
						<pre className="error-details__pre">{error.stack}</pre>
					</div>
				)}
			</div>
		</details>
	)
}
